<template>
  <div>
    <modal-crear-editar :configuracion="configuracion_modal" @realizado="restablecer_inputs"></modal-crear-editar>
    <tablita @cargar="cargar($event)" @cargar_url="cargar_url($event)" @nuevo="crear" @editar="editar($event)"
      :configuracion="configuracion_tabla" @formula="modal_formula($event)" @alertas="configurar_alertas($event)"
      @destinatarios="configurar_usuarios_correo($event)" @refresh="refrescar($event)" :cols="columnas"></tablita>
    <!-- <pre>{{item_analisis}}</pre> -->

    <!-- Modal Formula -->
    <div class="modal fade" id="modalformula" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div :class="`modal-dialog modal-dialog-centered modal-xl`" role="document" style="width: 1000px !importan">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Configuración de Fórmula:
              {{
                parametro_actual
                  ? `${parametro_actual.parametro.nombre} - ${parametro_actual.item_analisis_texto}`
                  : ""
              }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <button class="btn btn-success btn-sm" @click="agregar_paso">
                  Agregar Paso
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-sm table-bordered">
                    <thead class="thead-skyblue2">
                      <th>Orden</th>
                      <th>Tipo Valor 1</th>
                      <th>Valor 1</th>
                      <th>Parametro 1</th>
                      <th>Operador</th>
                      <th>Tipo Valor 2</th>
                      <th>Valor 2</th>
                      <th>Parametro 2</th>
                      <th>Eliminar</th>
                    </thead>
                    <tbody>
                      <tr v-for="(item, idx) in pasos_formula" :key="idx">
                        <td class="text-center">
                          <input type="number" name="" id="" v-model="item.orden" />
                        </td>
                        <td class="text-center">
                          <select name="" id="" v-model="item.tipo_valor_1">
                            <option :value="opc.id" v-for="opc in tipo_valores" :key="opc.id">
                              {{ opc.valor }}
                            </option>
                          </select>
                        </td>
                        <td class="text-center">
                          <input type="number" name="" id="" v-model="item.valor_1" />
                        </td>
                        <td class="text-center">
                          <select name="" id="" v-model="item.lab_item_parametros_id1">
                            <option value="">-- Sin Selección--</option>
                            <option v-for="opc in lab_parametros" :key="opc.id" :value="opc.id">
                              {{ `${opc.parametro_completo}` }}
                            </option>
                          </select>
                        </td>
                        <td class="text-center">
                          <select name="" id="" v-model="item.operador">
                            <option :value="opc.id" v-for="opc in operadores" :key="opc.id">
                              {{ opc.valor }}
                            </option>
                          </select>
                        </td>
                        <td class="text-center">
                          <select name="" id="" v-model="item.tipo_valor_2">
                            <option :value="opc.id" v-for="opc in tipo_valores" :key="opc.id">
                              {{ opc.valor }}
                            </option>
                          </select>
                        </td>
                        <td class="text-center">
                          <input type="number" name="" id="" v-model="item.valor_2" />
                        </td>
                        <td class="text-center">
                          <select name="" id="" v-model="item.lab_item_parametros_id2">
                            <option value="">-- Sin Selección--</option>
                            <option v-for="opc in lab_parametros" :key="opc.id" :value="opc.id">
                              {{ `${opc.parametro_completo}` }}
                            </option>
                          </select>
                        </td>
                        <td class="text-center">
                          <button class="btn btn-sm btn-danger" @click="eliminar_paso(item, idx)">
                            <i class="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- <pre>{{parametro_actual}}</pre> -->
            <!-- <pre>{{pasos_formula}}</pre> -->
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal" @click="guardar_formula">
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Formula -->

    <!-- Modal Configuracion Alertas-->
    <div class="modal fade" id="modal_alertas" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Configuracion de Alertas
              <strong>{{
                parametro_actual ? parametro_actual.parametro_completo : ""
              }}</strong>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <div :class="`alert ${alert_modal_correo_clase} alert-dismissible fade show`" role="alert" v-show="alert_modal_correo">
                    <span class="alert-icon"><i class="ni ni-like-2"></i></span>
                    <span class="alert-text"><strong></strong> {{alert_modal_correo_mensaje}}</span>
                    <button type="button" class="close" @click="alert_modal_correo = !alert_modal_correo" aria-label="Close">
                        <span aria-hidden="true" class="cruz">&times;</span>
                    </button>
                </div> -->
            <div class="row">
              <div class="col">
                <button class="btn btn-success btn-sm float-right" @click="agregar_alerta()">
                  <i class="fas fa-plus"></i> Agregar
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col fixTableHead">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center">Id</th>
                      <th class="text-center">Minimo</th>
                      <th class="text-center">Maximo</th>
                      <th class="text-center" width="300px">Empresas</th>
                      <th class="text-center">Eliminar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(a, idx) in alertas" :key="idx">
                      <td>{{ a.id }}</td>
                      <td class="text-center">
                        <input type="number" name="" id="" v-model="a.minimo" />
                      </td>
                      <td class="text-center">
                        <input type="number" name="" id="" v-model="a.maximo" />
                      </td>
                      <td class="text-center">
                        <v-select class="" :reduce="(option) => option.id" v-model="a.empresas_ids" :options="empresas"
                          label="nombre" multiple>
                          <template v-slot:no-options="{ search, searching }">
                            <template v-if="searching">
                              No se Encontraron Resultados Para
                              <em>{{ search }}</em>.
                            </template>
                            <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                          </template>
                        </v-select>
                      </td>
                      <td class="text-center">
                        <button class="btn btn-danger btn-sm" @click="eliminar_alerta(a, idx)">
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- <pre>{{parametro_actual}}</pre> -->
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">
              Cerrar
            </button>
            <button type="button" class="btn btn-success btn-sm" @click="guardar_alertas()">
              <i class="fas fa-save"></i> Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Configuracion Alertas-->

    <!-- Modal Configuracion Destinatarios Correo-->
    <div class="modal fade" id="modal_destinatarios" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Configuracion de Destinatarios
              <strong>{{
                parametro_actual ? parametro_actual.parametro_completo : ""
              }}</strong>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col fixTableHead">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center">Nombre</th>
                      <th class="text-center">Correo</th>
                      <th class="text-center">Asignar</th>
                      <th class="text-center">Tipo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(d, idx) in destinatarios_correos" :key="idx">
                      <td>{{ d.nombre }}</td>
                      <td>{{ d.correo }}</td>
                      <td>
                        <input type="checkbox" name="" id="" :value="d.id" v-model="d.check" />
                      <td>
                        <select class="form-control" v-model="d.tipos_destinatarios_id">
                          <option value="1">CC</option>
                          <option value="2">CCO</option>
                        </select>
                      </td>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">
              Cerrar
            </button>
            <button type="button" class="btn btn-success btn-sm" @click="guardar_destinatarios()">
              <i class="fas fa-save"></i> Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Tabla from "../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      {
        key: "id",
        label: "Id",
        busqueda: "",
        tipo: "number",
        searchable: false,
        path: "id",
      },
      {
        key: "lab_item_analisis_id",
        label: "Item Analisis",
        busqueda: "",
        tipo: "select",
        searchable: true,
        path: "item_analisis_texto",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        key: "lab_parametros_id",
        label: "Parametro",
        busqueda: "",
        tipo: "select",
        searchable: true,
        path: "parametro_texto",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        key: "mp_tipos_id",
        label: "Materia Prima",
        busqueda: "",
        tipo: "select",
        searchable: true,
        path: "materia_prima_texto",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        key: "tiene_adjunto",
        label: "Permitir Adjunto",
        busqueda: "",
        tipo: "html_select",
        searchable: true,
        path: "tiene_adjunto_html",
        opciones: [
          { id: 1, nombre: "Si" },
          { id: 0, nombre: "No" },
        ],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        key: "tiene_formula",
        label: "Tiene Formula",
        busqueda: "",
        tipo: "html_select",
        searchable: true,
        path: "formula_html",
        opciones: [
          { id: 1, nombre: "Si" },
          { id: 0, nombre: "No" },
        ],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        key: "tiene_alerta",
        label: "Tiene Alerta",
        busqueda: "",
        tipo: "html_select",
        searchable: true,
        path: "tiene_alerta",
        opciones: [
          { id: 1, nombre: "Si" },
          { id: 0, nombre: "No" },
        ],
        valor_opcion: "id",
        label_opcion: "nombre",
      },

      //{key:'tiene_alerta',label:'Tiene Alerta',busqueda:'',tipo:'icono',searchable:true,path:'tiene_alerta',icono:'fas fa-check',style:'color:#3c6591;cursor:pointer; font-size:1.5em;'},

      {
        key: "orden",
        label: "Orden",
        busqueda: "",
        tipo: "number",
        searchable: true,
        path: "orden",
      },
      {
        key: "activo",
        label: "Activo",
        busqueda: "",
        tipo: "html",
        searchable: true,
        path: "activo_html",
      },
    ],
    botones: [
      {
        label: "Editar",
        clase: "btn-warning",
        evento: "editar",
        icono: "fa fa-pen",
      },
      {
        label: "Formula",
        clase: "btn-primary",
        evento: "formula",
        icono: "fa fa-calculator",
      },
      {
        label: "Alertas",
        clase: "btn-danger",
        evento: "alertas",
        icono: "fas fa-exclamation-triangle",
      },
      {
        label: "Destinatarios Alerta",
        clase: "btn-danger",
        evento: "destinatarios",
        icono: "fas fa-envelope",
      },
    ],
    lista: [],
    links: [],
    inputs: [
      {
        cols: 6,
        tipo: "select",
        key: "lab_item_analisis_id",
        valor: "",
        label: "Item Análisis (*)",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        cols: 6,
        tipo: "select",
        key: "lab_parametros_id",
        valor: "",
        label: "Parámetro (*)",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        cols: 6,
        tipo: "select",
        key: "mp_tipos_id",
        valor: "",
        label: "Materia Prima",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        cols: 6,
        tipo: "multiselect",
        key: "productos_recibidos_ids",
        valor: "",
        label: "Producto Recibido",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      { cols: 6, tipo: "numero", key: "orden", valor: true, label: "Orden" },
      {
        cols: 3,
        tipo: "checkbox",
        key: "activo",
        valor: true,
        label: "Activo",
      },
      {
        cols: 3,
        tipo: "checkbox",
        key: "tiene_adjunto",
        valor: true,
        label: "Permitir Adjunto",
      },
    ],
    configuracion_modal: {
      titulo: "Registrar Item Analisis Parámetros",
      ancho: "xl",
      ruta: "/lab_item_parametros",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Item Analisis Parámetros",
      titulo_boton: "Crear Item Analisis Parámetro",
      clase_boton: "btn-primary",
      btn_nuevo: true,
    },
    pagina_actual: "",
    parametros: [],
    item_analisis: [],
    pasos_formula: [],
    tipo_valores: [],
    operadores: [],
    parametro_actual: null,
    materia_primas: [],
    destinatarios_ids: [],
    destinatarios_correos: [],
    destinatarios:[],
    alertas: [],
    empresas: [],
    productos_recibidos:[]
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }
    this.cargar_item_analisis();
    this.cargar_productos_recibidos();
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async cargar_item_analisis() {
      await this.axios
        .get(
          `${this.api}/lab_item_analisis?limit=999999999`,
          this.cabeceras_json
        )
        .then((res) => {
          this.item_analisis = res.data.data.data;
          this.inputs[0].opciones = this.item_analisis;
          this.columnas[1].opciones = this.item_analisis;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_parametros();
      //this.cargar_tipo_valores();
    },

    async cargar_productos_recibidos() {
      await this.axios
        .get(
          `${this.api}/productos_recibidos?limit=999999999`,
          this.cabeceras_json
        )
        .then((res) => {
          this.productos_recibidos = res.data.data.data;
          this.inputs[3].opciones = this.productos_recibidos;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_parametros();
      //this.cargar_tipo_valores();
    },

    async cargar_parametros() {
      await this.axios
        .get(`${this.api}/lab_parametros?limit=999999999`, this.cabeceras_json)
        .then((res) => {
          this.parametros = res.data.data.data;
          this.inputs[1].opciones = this.parametros;
          this.columnas[2].opciones = this.parametros;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_materias_primas();
      //this.cargar('')
    },

    async cargar_materias_primas() {
      await this.axios
        .get(`${this.api}/mps_tipo?limit=999999999`, this.cabeceras_json)
        .then((res) => {
          this.materias_primas = res.data.data.data;
          this.inputs[2].opciones = this.materias_primas;
          this.columnas[3].opciones = this.materias_primas;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_tipo_valores();
    },
    async cargar_tipo_valores() {
      await this.axios
        .get(`${this.api}/formula/tipo_valores`, this.cabeceras_json)
        .then((res) => {
          this.tipo_valores = res.data.data;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_operadores();
    },
    async cargar_operadores() {
      await this.axios
        .get(`${this.api}/formula/operadores`, this.cabeceras_json)
        .then((res) => {
          this.operadores = res.data.data;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_empresas();
      //this.cargar_parametros()
    },

    async cargar_empresas() {
      await this.axios
        .get(
          `${this.api}/empresas?tipo_empresa_ids=4&limit=999999999`,
          this.cabeceras_json
        )
        .then((res) => {
          this.empresas = res.data.data.data;
        })
        .catch((e) => {
          //alert(e);
        });
      this.cargar_destinatarios();
    },

    async cargar_destinatarios() {
      await this.axios
        .get(`${this.api}/destinatarios?limit=99999`, this.cabeceras_json)
        .then(async (res) => {
          this.destinatarios_correos = res.data.data.data;
          await this.resetear_destinatarios_correos();
        })
        .catch((e) => {
          //console.log(e);
        });
      //this.cargar("");
      this.$emit("cargar");
    },

    async cargar_parametros_mp(mps_id) {
      await this.axios
        .get(
          `${this.api}/configuracion_formulas/mps_id/${mps_id}/cargar_parametros`,
          this.cabeceras_json
        )
        .then((res) => {
          this.lab_parametros = res.data.data;
          console.log("cargo?", res.data);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    /* async cargar_lab_parametros(){
            await this.axios.get(`${this.api}/lab_item_parametros?limit=999999999`,this.cabeceras_json).then((res)=>{
                this.lab_parametros = res.data.data.data;
            }).catch((e)=>{
                //console.log(e);
            });
            this.cargar('')
        }, */

    async cargar($event) {
      this.pagina_actual = `${this.api}/lab_item_parametros${$event}`;
      this.lista = [];
      await this.axios
        .get(`${this.api}/lab_item_parametros${$event}`, this.cabeceras_json)
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
          this.$emit("generar", this.columnas, this.lista);
          ////console.log('listado',res.data.data.data);
          //$('#empresas').DataTable().draw();
        })
        .catch((e) => {
          //alert(e);
        });
    },
    async cargar_url(url) {
      if (url) {
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
      }
    },
    crear() {
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/lab_item_parametros`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });
      });
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/lab_item_parametros/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },
    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.setear_inputs(this.inputs);
    },

    async modal_formula($event) {
      this.parametro_actual = $event.item;
      await this.cargar_parametros_mp(
        this.parametro_actual.item_analisis.mp_tipos_id
      );
      this.pasos_formula = $event.item.pasos_formulas;
      $("#modalformula").modal({ show: true });
    },
    agregar_paso() {
      this.pasos_formula.push({
        id: null,
        lab_parametro_principal: this.parametro_actual.id,
        tipo_valor_1: null,
        valor_1: "",
        lab_item_parametros_id1: null,
        tipo_valor_2: null,
        valor_2: "",
        lab_item_parametros_id2: null,
        orden: null,
      });
    },

    async guardar_formula() {
      await this.axios
        .post(
          `${this.api}/lab_item_parametros/${this.parametro_actual.id}/guardar_pasos_formula`,
          { pasos: this.pasos_formula },
          this.cabeceras_json
        )
        .then((res) => {
          this.pasos_formula = [];
          this.parametro_actual = null;
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    async eliminar_paso(item, idx) {
      if (item.id != null) {
        await this.axios
          .delete(
            `${this.api}/lab_parametro_formulas/${item.id}`,
            this.cabeceras_json
          )
          .then((r) => {
            this.pasos_formula.splice(idx, 1);
          })
          .catch((e) => {
            console.log("No se pudo Eliminar");
          });
      } else {
        this.pasos_formula.splice(idx, 1);
      }
    },

    async configurar_alertas(event) {
      this.parametro_actual = event.item;
      this.destinatarios_ids = event.item.destinatarios_ids;
      await this.axios
        .get(
          `${this.api}/lab_item_parametros/${event.item.id}/cargar_alertas`,
          this.cabeceras_json
        )
        .then((res) => {
          this.alertas = res.data.data;
          ////console.log(res.data);
        })
        .catch((e) => {
          //console.log(e);
        });
      //this.usuarios_ids = p.usuarios_correo_ids;

      $("#modal_alertas").modal({ show: true });
    },

    agregar_alerta() {
      this.alertas.push({
        id: null,
        minimo: null,
        maximo: null,
        empresas_ids: [],
      });
    },

    async guardar_alertas() {
      let body = {
        alertas: this.alertas,
      };
      await this.axios
        .post(
          `${this.api}/lab_item_parametros/${this.parametro_actual.id}/guardar_alertas`,
          body,
          this.cabeceras_json
        )
        .then((res) => {
          //console.log(res.data);

          this.cargar("");
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    async eliminar_alerta(alerta, idx) {
      if (alerta.id != null) {
        await this.axios
          .delete(`${this.api}/lab_alertas/${alerta.id}`, this.cabeceras_json)
          .then((res) => {
            this.alertas.splice(idx, 1);
          })
          .catch((e) => {
            //console.log(e);
          });
      } else {
        this.alertas.splice(idx, 1);
      }
    },

    async configurar_usuarios_correo(event) {
      this.parametro_actual = event.item;
      await this.axios
        .get(
          `${this.api}/lab_item_parametros/${event.item.id}`,
          this.cabeceras_json
        )
        .then((res) => {
          this.destinatarios_ids = res.data.data.destinatarios_ids;
          this.destinatarios = res.data.data.destinatarios;
          ////console.log(this.destinatarios_ids);
        })
        .catch((e) => {
          //console.log(e);
        });
      //this.usuarios_ids = p.usuarios_correo_ids;
      await this.resetear_destinatarios_correos();
      //this.destinatarios_ids = p.destinatarios_ids;
      await this.setear_destinatarios_correos();
      $("#modal_destinatarios").modal({ show: true });
    },

    resetear_destinatarios_correos() {
      this.destinatarios_correos.forEach((d, idx) => {
        this.$set(this.destinatarios_correos[idx], "check", false);
        this.$set(this.destinatarios_correos[idx], "tipos_destinatarios_id", "");
      });
    },

    setear_destinatarios_correos() {
      this.destinatarios_correos.forEach((d) => {
        let check = this.destinatarios_ids.findIndex((id) => d.id == id);
        if (check != -1) {
          d.check = true;
          let id = this.destinatarios_ids[check];
          let destinatario = this.destinatarios.find(des => des.id == id);
          d.tipos_destinatarios_id = destinatario.pivot.tipos_destinatarios_id;
        }
      });
    },

    async guardar_destinatarios() {
      let body = {
        destinatarios_ids: this.destinatarios_correos
          .filter((d) => d.check == true)
          .map((d) => ({id:d.id,tipos_destinatarios_id:d.tipos_destinatarios_id}))
      };
      await this.axios
        .post(
          `${this.api}/lab_item_parametros/${this.parametro_actual.id}/guardar_destinatarios`,
          body,
          this.cabeceras_json
        )
        .then((res) => {
          //console.log(res.data);

          this.cargar("");
        })
        .catch((e) => {
          //console.log(e);
        });
    },
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },
    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>